import React from 'react';
import ContentSection from './contentSection';

const WHAT_ARE_STEROIDS = [
  {
    title: "Performance-enhancing drugs (PEDs)",
    description: "PEDs are any substances taken to improve physical activity, performance, or image. Steroids are performance-enhancing drugs, but there are also other types."
  },
  {
    title: "Testosterone",
    description: "Testosterone is the male sex hormone. It's produced in the testes and plays a role in the development of male sexual characteristics."
  },
  {
    title: "Anabolic androgenic steroids (AAS)",
    description: "Anabolic androgenic steroids are synthetic versions of testosterone. Like naturally produced testosterone, AAS usage can increase male sex characteristics and muscle."
  }
];

const WhatAreSteroids = () => {
  return (
    <section className="content-section">
      <h2>What are steroids?</h2>
      <ContentSection data={WHAT_ARE_STEROIDS}/>
    </section>
  );
}

export default WhatAreSteroids;